module.exports = __webpack_public_path__ + "static/McAfee-Logo-0a47058267ecd47cc025d7a38db8c851.svg";